export const createLatestDepartmentConfigLoader = () => {
  let revision = 0;

  return {
    invalidate() {
      revision += 1;
    },

    async load(departmentId, request) {
      const requestRevision = ++revision;
      try {
        const response = await request(departmentId);
        return requestRevision === revision ? response : null;
      } catch (error) {
        if (requestRevision !== revision) return null;
        throw error;
      }
    },
  };
};
